import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Marquee from "@/components/Marquee";
import Footer from "@/components/Footer";
import CategoriesGallery from "@/components/CategoriesGallery";
import PublicStats from "@/components/PublicStats";
import ServicesTeaser from "@/components/ServicesTeaser";
import ApplyTeaser from "@/components/ApplyTeaser";
import DirectorContact from "@/components/DirectorContact";
import SponsorBanner from "@/components/SponsorBanner";
import MissionSection from "@/components/MissionSection";
import MediaPartners from "@/components/MediaPartners";
import SocialHub from "@/components/SocialHub";

const HERO =
  "https://images.pexels.com/photos/13331292/pexels-photo-13331292.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1100&w=1900";

export default function Landing() {
  return (
    <div className="pt-20">
      {/* Hero */}
      <section
        className="relative min-h-[85vh] flex flex-col justify-end"
        data-testid="hero-section"
      >
        <div className="absolute inset-0 overflow-hidden">
          <img
            src={HERO}
            alt="Teatro con velluto rosso e lampadario"
            className="w-full h-full object-cover"
            data-testid="hero-bg-image"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0908] via-[#0a0908]/60 to-[#0a0908]/25" />
          <div className="absolute inset-0 bg-[#0a0908]/25" />
        </div>

        <div className="relative max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 pb-16 pt-40">
          <span className="av-eyebrow" data-testid="hero-eyebrow">
            Vetrina proposte artistiche
          </span>
          <h1
            className="font-serif-display text-4xl sm:text-5xl lg:text-7xl leading-[1.05] mt-6 max-w-4xl"
            data-testid="hero-title"
          >
            Artisti e{" "}
            <span className="italic text-[#E5A93C]">spettacoli</span>
            <br />
            per la tua <span className="italic text-[#E5A93C]">piazza</span>.
          </h1>
          <p className="mt-6 text-[#F7F4EE]/70 max-w-xl text-base sm:text-lg">
            Un archivio curato di proposte pronte per enti, comuni, associazioni e
            locali. Sfoglia il catalogo, scegli l'artista o lo spettacolo, richiedi la
            proposta su misura a NMA Agency con un click.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link
              to="/artisti"
              className="av-pill av-pill-gold"
              data-testid="explore-artists-btn"
            >
              Esplora artisti <ArrowRight size={16} />
            </Link>
            <Link
              to="/spettacoli"
              className="av-pill av-pill-ghost"
              data-testid="explore-shows-btn"
            >
              Vedi gli spettacoli
            </Link>
          </div>
        </div>
      </section>

      <Marquee />

      <div id="sec-direttore">
        <DirectorContact />
      </div>

      <div id="sec-sponsor">
        <SponsorBanner slot="top" />
      </div>

      <PublicStats />

      <div id="sec-missione">
        <MissionSection />
      </div>

      <div id="sec-categorie">
        <CategoriesGallery />
      </div>

      <SponsorBanner slot="mid" />

      <div id="sec-servizi">
        <ServicesTeaser />
      </div>

      <div id="sec-community">
        <SocialHub />
      </div>

      <div id="sec-partner">
        <MediaPartners />
      </div>

      <div id="sec-candidati">
        <ApplyTeaser />
      </div>

      {/* Value proposition */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="grid md:grid-cols-3 gap-6" data-testid="value-props">
          {[
            {
              n: "01",
              t: "Scegli dal catalogo",
              d: "Artisti verificati e spettacoli pronti, filtrabili per disciplina e città.",
            },
            {
              n: "02",
              t: "Componi il tuo evento",
              d: "Aggiungi artisti e spettacoli alla tua bozza, indica data, luogo e budget.",
            },
            {
              n: "03",
              t: "Preventivo NMA in 24h",
              d: "Ricevi la proposta economica su misura. Un solo interlocutore per tutta la produzione.",
            },
          ].map((s) => (
            <div key={s.n} className="av-card p-8" data-testid={`value-${s.n}`}>
              <div className="text-[#E5A93C] font-mono text-sm">{s.n}</div>
              <h3 className="font-serif-display text-2xl mt-3">{s.t}</h3>
              <p className="text-[#A39E93] mt-3 text-sm leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA band */}
      <section className="border-y av-hairline bg-[#141210]/60">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 flex flex-col md:flex-row items-start md:items-center gap-6 justify-between">
          <div>
            <span className="av-eyebrow">Come funziona</span>
            <h2 className="font-serif-display text-3xl sm:text-4xl mt-3">
              Un click. <span className="italic text-[#E5A93C]">NMA</span> pensa a tutto.
            </h2>
          </div>
          <Link
            to="/richiedi"
            className="av-pill av-pill-gold"
            data-testid="cta-request-quote"
          >
            Richiedi un preventivo <ArrowRight size={16} />
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
